import { CSSProperties } from 'react';
import { tokens } from '@synergy/theme-palo';

/**
 * The picture in a row of the master data lists. The avatar kept the type size
 * of the 40-pixel one, so "MM" ran out of a 24-pixel circle, white on light
 * grey (#2212).
 */
export const PALO_LIST_AVATAR_STYLE: CSSProperties = {
    width: 24,
    height: 24,
    fontSize: 10,
    fontWeight: 600,
    color: tokens.color.ink2,
};
